export default __webpack_public_path__ + "static/IBMPlexSans-TextItalic-29eb44465d909daaba390092474e0ec6.woff2";